<template>
  <div class="logTableContainer">
    <!-- 系统列表 -->
    <a-table id="myServiceTable" :columns="columns" :data-source="tableData"  :pagination="false"  :scroll="{ x: clientWidth}"  :loading="tloading" rowKey="traceid"
    bordered size="middle" @change="handleTableChange">
        <template slot="resultText" slot-scope="text">
            <span v-if="text=='true'" style="color:green;" >成功</span>
            <span v-else style="color:red;">失败</span>
        </template>
        <template slot="timeText" slot-scope="text">
            <span style="" >{{ (new Date(text)).Format("yy-MM-dd hh:mm:ss") }}</span>
        </template>

        <!-- 报文 -->
        <template slot="readParams" slot-scope="text,record">
            <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParams(record)" />
        </template>

        <!-- 链路 -->
        <template slot="relactionP" slot-scope="text,record">
            <a-icon style="color:#1890ff;" size="large" type="apartment" @click="handleRelation(record)" />
        </template>

        <!-- SKYWALKING链路 -->
        <template slot="relactionSkywalkingP" slot-scope="text,record">
            <a-icon style="color:#1890ff;" size="large" type="apartment" @click="handleRelationSkywalking(record)" />
        </template>
    </a-table>

    <a-pagination  style="margin-top:20px;" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" show-less-items show-quick-jumper />

    <a-modal v-model="modalVisible" title="报文" @ok="handleOk">
        <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="请求参数">

                <json-viewer
                :value="currentRequest"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-tab-pane>
            <a-tab-pane key="2" tab="响应结果">
                <json-viewer
                :value="currentResponse"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-tab-pane>
        
            </a-tabs>
    </a-modal>

  </div>
</template>
<script>
import JsonViewer from "vue-json-viewer"
let pagenation ={
    current:1,
    pageSize:10,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagenation;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        },
        fixed: 'left'
    },
    {
        title: "报文",
        width:50,
        scopedSlots: { customRender: 'readParams' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "链路",
        width:50,
        scopedSlots: { customRender: 'relactionP' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },

    {
        title: "链路Sky",
        width:100,
        scopedSlots: { customRender: 'relactionSkywalkingP' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    

    {
        title: "系统编码",
        dataIndex: "appcode",
        width:100,
        align: "center",

    },
    {
        title: "调用方编码",
        dataIndex: "invokeappcode",
        width:100,
        align: "center",
    },
    {
        title: "traceid",
        dataIndex: "traceid",
        width:450,
        align: "left",
        ellipsis: true
    },
    {
        title: "URL",
        dataIndex: "url",
        width:500,
        align: "left",
        ellipsis: true
    },
    {
        title: "请求类型",
        dataIndex: "bptype",
        width:80,
        align: "center",
        ellipsis: true
    }
    ,
    {
        title: "IP",
        dataIndex: "clientip",
        width:150,
        align: "center",
        ellipsis: true
    },
    {
        title: "开始时间",
        dataIndex: "starttime",
        width:140,
        align: "center",
        scopedSlots: { customRender: 'timeText' },
        sorter: true,
        defaultSortOrder :'descend',
        ellipsis: true
    },
    {
        title: "结束时间",
        dataIndex: "endtime",
        width:140,
        align: "center",
        scopedSlots: { customRender: 'timeText' },
        ellipsis: true
    },
    {
        title: "耗时（ms）",
        dataIndex: "handtime",
        width:100,
        align: "center",
        sorter: true,
        ellipsis: true
    },
    {
        title: "调用结果",
        dataIndex: "success",
        width:80,
        align: "center",
        ellipsis: true,
        sorter: true,
        scopedSlots: { customRender: 'resultText' },
    },
    {
        title: "异常编码",
        dataIndex: "exceptioncode",
        width:200,
        align: "left",
        sorter: true,
        ellipsis: true
    },
    {
        title: "异常类型",
        dataIndex: "exceptiontype",
        width:80,
        align: "center",
        ellipsis: true
    },
    {
        title: "运行环境",
        dataIndex: "routetag",
        width:80,
        align: "center",
        ellipsis: true
    },
    


    
    // {
    //     title: "traceid",
    //     dataIndex: "traceid",
    //     width:100,
    //     align: "left",
    //     ellipsis: true
    // }
];


export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagenation,
            oldPageNum:1,
            clientWidth:800,
            modalVisible:false,
            currentRequest:"",
            currentResponse:"",
            tempSearchKey:{},
            
            orderStr:'order by starttime desc'
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.orderStr = ' order by ' + sorter.field + ' ' + sorter.order.replace('end','');
            }
            else{
                this.orderStr = '';
            }
            this.getAppSumData(this.tempSearchKey);
        },
        handlePageChange(v){
            this.pagenation.current = v
            this.getAppSumData(this.tempSearchKey);
        },
        handleOk(){
            this.modalVisible = false;
        },
        getAppSumData(searchKey){
            this.tempSearchKey = searchKey
            let searchAppcode = searchKey.selectedAppcode;
            let searchInvokAppcode = searchKey.selectedInvokeappcode;
            let servicekey = searchKey.servicekey;
            let logKeyWord = searchKey.logKeyWord;
            let logTraceid = searchKey.logTraceid;
            let clientip = searchKey.clientip;
            let whereStr = " where 1=1 ";
            if(searchAppcode){
                whereStr += "and AppCode = '" + searchAppcode + "' ";
            }
            if(searchInvokAppcode){
                whereStr += "and invokeappcode = '" + searchInvokAppcode + "' ";
            }
            if(servicekey){
                whereStr += "and url = '" + servicekey + "' ";
            }
            if(logKeyWord){
                whereStr += "and (requestparams like '%" + logKeyWord + "%'  or responseresult like '%" + logKeyWord + "%') ";
            }
            if(logTraceid){
                whereStr += "and traceid = '" + logTraceid + "' ";
            }
            if(clientip){
                whereStr += "and clientip = '" + clientip + "' ";

            }
            
            let queryStr = "* | select appcode,bptype,clientip,endtime,exceptioncode,exceptiontype,"+
                           "handtime,invokeappcode,requestparams,responseresult,starttime,success,traceid,url from log ";
    
            queryStr += whereStr;
            queryStr += this.orderStr
            let that = this;
            that.tloading = true;
            let starttime = (new Date(searchKey.searchTimeRange.split('~')[0]).getTime())/1000;
            let endtime = (new Date(searchKey.searchTimeRange.split('~')[1]).getTime())/1000;
            let params = {
                projectname:that.G.getServiceMonitorName(),
                logstorename:'service-monitor',
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:that.pagenation.pageSize,
                offset:(that.pagenation.current - 1) * that.pagenation.pageSize,
                reverse:false,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagenation.total = parseInt(result.count);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleParams(item){
            this.modalVisible = true;
            try {
                this.currentRequest = JSON.parse(item.requestparams);
            } catch (error) {
                this.currentRequest = item.requestparams;
            }
            
            try {
                this.currentResponse = JSON.parse(item.responseresult);
            } catch (error) {
                this.currentResponse = item.responseresult;
            }
        },
        handleRelation(item){
            //链路上下十分钟时间
            let timePoint = item.starttime;
            let starttime = new Date(timePoint).getTime() - 10 * 60000;
            let endtime = new Date(timePoint).getTime() + 10 * 60000;
            // console.log("start:" + new Date(starttime).Format('yyyy-MM-dd hh:mm:ss'));
            // console.log("end:" + new Date(endtime).Format('yyyy-MM-dd hh:mm:ss'));
            let routeResolve =this.$router.resolve({
                path:"relation",
                query:{
                    traceid:item.traceid,
                    starttime:starttime,
                    endtime:endtime
                }
            })
            window.open(routeResolve.href, '_blank');
        },
        handleRelationSkywalking(item){
            //链路上下十分钟时间
            let timePoint = item.starttime;
            let starttime = new Date(timePoint).getTime() - 10 * 60000;
            let endtime = new Date(timePoint).getTime() + 10 * 60000;
            // console.log("start:" + new Date(starttime).Format('yyyy-MM-dd hh:mm:ss'));
            // console.log("end:" + new Date(endtime).Format('yyyy-MM-dd hh:mm:ss'));
            let routeResolve =this.$router.resolve({
                path:"/prod/skywalking",
                query:{
                    traceid:item.traceid,
                    starttime:starttime,
                    endtime:endtime
                }
            })
            window.open(routeResolve.href, '_blank');
        },
    },
  
    components:{
        JsonViewer,
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagenation{
        margin-top: 10px;
    }

    .logTableContainer{
        width: 100%;
        position:relative;
        height: auto;
        overflow: hidden;
    }


</style>

<style >

</style>
